import toast from 'react-hot-toast';

export const showSuccessMessage = (message: string, description?: string) => {
    toast.success(description ? `${message}\n${description}` : message, {
        duration: 3000,
        style: {
            background: '#10b981',
            color: '#ffffff',
        },
        iconTheme: {
            primary: '#ffffff',
            secondary: '#10b981',
        },
    });
};

export const showErrorMessage = (message: string, description?: string) => {
    toast.error(description ? `${message}\n${description}` : message, {
        duration: 4000,
        style: {
            background: '#ef4444',
            color: '#ffffff',
        },
        iconTheme: {
            primary: '#ffffff',
            secondary: '#ef4444',
        },
    });
};

export const showInfoMessage = (message: string, description?: string) => {
    toast(description ? `${message}\n${description}` : message, {
        duration: 3000,
        icon: 'ℹ️',
        style: {
            background: '#3b82f6',
            color: '#ffffff',
        },
        iconTheme: {
            primary: '#ffffff',
            secondary: '#3b82f6',
        },
    });
};

export const showWarningMessage = (message: string, description?: string) => {
    toast(description ? `${message}\n${description}` : message, {
        duration: 3000,
        icon: '⚠️',
        style: {
            background: '#f59e0b',
            color: '#ffffff',
        },
        iconTheme: {
            primary: '#ffffff',
            secondary: '#f59e0b',
        },
    });
};

// Re-export the original toast function for custom usage
export { toast as showMessage }; 